"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddSignature = void 0;
const doshx_controls_web_1 = require("doshx_controls_web");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_signature_pad_wrapper_1 = __importDefault(require("react-signature-pad-wrapper"));
const main_1 = require("../../../../../reducers/slices/main");
const document_1 = require("../../../../../reducers/slices/document/document");
const constants_1 = require("../../../../../constants/constants");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const AddSignature = ({ onClick, value, type = "Signature", hide = false, }) => {
    const { signature } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const { user, token, isLoading } = (0, react_redux_1.useSelector)((state) => state.userState);
    const [selectedTabIndex, setSelectedTabIndex] = (0, react_1.useState)(0);
    const [file, setFile] = (0, react_1.useState)("");
    const dispatch = (0, react_redux_1.useDispatch)();
    const signatureRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        dispatch((0, document_1.setSignature)(value));
    }, []);
    const toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.TabControl, { selectedTabIndex: selectedTabIndex, tabs: [
                ...(!hide
                    ? [
                        {
                            title: `Saved ${type}`,
                            content: (react_1.default.createElement("div", { className: "flex flex-col gap-4 w-full max-w-sm min-h-96 m-auto mt-4" }, (type === "Initials" ? user === null || user === void 0 ? void 0 : user.initials : user === null || user === void 0 ? void 0 : user.signature) ? (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("img", { src: type === "Initials" ? user.initials : user.signature, alt: `Saved ${type}` }),
                                react_1.default.createElement("div", { className: "flex justify-evenly mt-4" },
                                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Use This", size: "small", backgroundColor: "bg-secondary", textColor: "text-white", onClick: () => {
                                            onClick(type === "Initials" ? user.initials : user.signature);
                                            return dispatch((0, main_1.setContentModal)(null));
                                        } })))) : (react_1.default.createElement("div", null, `No saved ${type.toLowerCase()} found.`)))),
                        },
                    ]
                    : []),
                {
                    title: `${type} Pad`,
                    content: (react_1.default.createElement("div", { className: "flex flex-col gap-4 w-full max-w-sm min-h-96 m-auto mt-4" },
                        signature && signature !== "" ? (react_1.default.createElement("div", { className: "" },
                            react_1.default.createElement("img", { src: signature }))) : (react_1.default.createElement("div", { className: "", style: { border: "1px solid #ccc", borderRadius: "8px" } },
                            react_1.default.createElement(react_signature_pad_wrapper_1.default, { ref: signatureRef, options: {
                                    backgroundColor: "transparent",
                                    penColor: "black",
                                }, width: typeof window !== "undefined" ? Math.min(384, window.innerWidth - 80) : 384, height: typeof window !== "undefined" ? Math.min(288, (window.innerWidth - 80) * 0.75) : 288 }))),
                        react_1.default.createElement("div", { className: "flex justify-evenly" },
                            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Clear", size: "small", backgroundColor: "bg-borders", textColor: "text-black", onClick: () => {
                                    var _a;
                                    dispatch((0, document_1.setSignature)(""));
                                    if (signatureRef) {
                                        (_a = signatureRef === null || signatureRef === void 0 ? void 0 : signatureRef.current) === null || _a === void 0 ? void 0 : _a.clear();
                                    }
                                    onClick("");
                                } }),
                            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Save", size: "small", backgroundColor: "bg-secondary", textColor: "text-white", onClick: () => {
                                    if (signature) {
                                        onClick(signature);
                                    }
                                    else if (signatureRef && signatureRef.current && !signatureRef.current.isEmpty()) {
                                        const image = signatureRef.current.canvasRef.current.toDataURL(constants_1.CANVAS_IMAGE_TYPE);
                                        if (image)
                                            onClick(image);
                                    }
                                    else {
                                        // If pad is empty, save as empty string
                                        onClick("");
                                    }
                                    return dispatch((0, main_1.setContentModal)(null));
                                } })))),
                },
                {
                    title: `Upload ${type}`,
                    content: (react_1.default.createElement("div", { className: "flex flex-col gap-4 w-full max-w-xs min-h-80 m-auto mt-4" },
                        file ? (react_1.default.createElement("div", { className: "" },
                            react_1.default.createElement("img", { src: file }))) : (react_1.default.createElement(doshx_controls_web_1.FileInputControl, { startIcon: pro_light_svg_icons_1.faFileArrowUp, previewSide: "right", colors: { iconColor: "text-blue-600", borderColor: "border-borders" }, size: "medium", previewFile: true, supportedFileTypes: [".png", ".jpeg"], onChange: (file) => __awaiter(void 0, void 0, void 0, function* () {
                                const _file = yield toBase64(file);
                                if (typeof _file === "string")
                                    setFile(_file);
                            }) })),
                        react_1.default.createElement("div", { className: "flex justify-evenly" },
                            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Upload", size: "small", backgroundColor: "bg-borders", textColor: "text-black", onClick: () => {
                                    setFile("");
                                } }),
                            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Save", size: "small", backgroundColor: "bg-secondary", textColor: "text-white", onClick: () => {
                                    if (file) {
                                        if (file)
                                            onClick(file);
                                        return dispatch((0, main_1.setContentModal)(null));
                                    }
                                } })))),
                },
            ], colors: {
                borderColor: "border-borders",
                tabs: {
                    textColor: "text-gray-800",
                    indicatorColor: "bg-primary",
                    backgroundColor: "bg-borders",
                    unselectedBackgroundColor: "bg-white",
                    selectedBackgroundColor: "bg-white",
                },
            } })));
};
exports.AddSignature = AddSignature;
